export interface SwipeGesture {
  deltaX: number
  deltaY: number
  durationMs: number
}

export type SwipeDirection = 'left' | 'right'

export const SWIPE_MIN_DISTANCE_PX = 48
export const SWIPE_MAX_DURATION_MS = 800
const HORIZONTAL_DOMINANCE_RATIO = 1.5

export function resolveSwipeDirection(
  gesture: SwipeGesture
): SwipeDirection | null {
  const { deltaX, deltaY, durationMs } = gesture
  if (durationMs > SWIPE_MAX_DURATION_MS) return null
  const absX = Math.abs(deltaX)
  if (absX < SWIPE_MIN_DISTANCE_PX) return null
  if (absX < Math.abs(deltaY) * HORIZONTAL_DOMINANCE_RATIO) return null
  return deltaX < 0 ? 'left' : 'right'
}

export function resolveSwipeTargetPage(
  gesture: SwipeGesture,
  currentPage: number,
  totalPages: number
): number | null {
  const direction = resolveSwipeDirection(gesture)
  if (direction === null) return null
  const target = direction === 'left' ? currentPage + 1 : currentPage - 1
  if (target < 1 || target > totalPages) return null
  return target
}
